import React, { useEffect, useState } from "react";
import Div from "../../../../widget/common/ui/Div";
import { CheckBoxRound } from "../../../../widget/common/ui/Checkbox";
import { TextBlock } from "../../../../widget/common/ui/Text";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { ButtonSingle } from "../../../../widget/common/form/Button";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import {
  ChatsContextImport,
  ChatsContextProvider,
} from "../../../../provider/chats/chats/chats/ChatsContextProvider";
import Center from "../../../../widget/common/ui/Center";
import Loader from "../../../../widget/common/ui/Loader";
import ChatsProvider from "../../../../provider/chats/chats/chats/ChatsProvider";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "../../../../libraries/state_reducers/store";
import {
  changeDepartmentMuteDuration,
  changeGroupMuteDuration,
  changeTeamMuteDuration,
} from "../../../../libraries/state_reducers/chats/ChatsReducer";

const ConversationMuteNotificationAlert = () => {
  const type: number = ResponsiveDeviceType();
  return (
    <ChatsContextProvider>
      <ConversationMuteNotificationAlertBody type={type} />
    </ChatsContextProvider>
  );
};

export default ConversationMuteNotificationAlert;

const ConversationMuteNotificationAlertBody = (props: { type: number }) => {
  const dispatch = useDispatch();

  const muteSettingsTeam = useSelector(
    (state: RootState) => state.chats.muteSettingsTeam
  );

  const muteSettingsDepartment = useSelector(
    (state: RootState) => state.chats.muteSettingsDepartment
  );

  const muteSettingsGroup = useSelector(
    (state: RootState) => state.chats.muteSettingsGroup
  );

  const { chatSelected, getSelectedChatSession } = ChatsContextImport();
  const flag: string = chatSelected?.flag ?? "1";

  const [choosingStatus, setchoosingStatus] = useState<boolean>(false);
  const [selectedDuration, setSelectedDuration] = useState<string>("-2");

  const handleDuration = (duration: string) => {
    if (duration !== selectedDuration) {
      setSelectedDuration(duration);
    }
    setchoosingStatus(true);
  };

  const submitDuration = () => {
    if (["1", "4"].includes(flag)) {
      dispatch(
        changeTeamMuteDuration(ChatsProvider.muteSettingValue(selectedDuration))
      );
    } else if (flag === "2") {
      dispatch(
        changeDepartmentMuteDuration(
          ChatsProvider.muteSettingValue(selectedDuration)
        )
      );
    } else if (flag === "3") {
      dispatch(
        changeGroupMuteDuration(
          ChatsProvider.muteSettingValue(selectedDuration)
        )
      );
    }
  };

  useEffect(() => {
    getSelectedChatSession();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      muteSettingsTeam != null &&
      muteSettingsTeam.mute_status &&
      ["1", "4"].includes(flag)
    ) {
      setSelectedDuration(muteSettingsTeam?.mute_duration!);
    }
  }, [muteSettingsTeam, flag]);

  useEffect(() => {
    if (
      muteSettingsDepartment != null &&
      muteSettingsDepartment.mute_status !== "0" &&
      flag === "2"
    ) {
      setSelectedDuration(muteSettingsDepartment?.mute_duration!);
    }
  }, [muteSettingsDepartment, flag]);

  useEffect(() => {
    if (
      muteSettingsGroup != null &&
      muteSettingsGroup.mute_status !== "0" &&
      flag === "3"
    ) {
      setSelectedDuration(muteSettingsGroup?.mute_duration!);
    }
  }, [muteSettingsGroup, flag]);

  const optionHtml = (
    title: string,
    status: boolean = false,
    func: () => void
  ): JSX.Element => {
    return (
      <div
        className="d-flex align-items-center py-1"
        role="button"
        onClick={func}
      >
        <CheckBoxRound status={status} />
        <span className="ps-2">
          <TextBlock fontName="medium" fontSize="14_15" textColor="theme-label">
            {AppTranslation.text(title)}
          </TextBlock>
        </span>
      </div>
    );
  };

  return (
    <>
      {chatSelected == null ? (
        <Center>{Loader.normal()}</Center>
      ) : (
        <Div className="px-3 px-lg-0">
          {Object.entries(ChatsProvider.muteOptions).map(([key, val]) => (
            <span key={key}>
              {optionHtml(key, selectedDuration === val, () =>
                handleDuration(val)
              )}
            </span>
          ))}

          {selectedDuration != null &&
            selectedDuration !== "-2" &&
            choosingStatus && (
              <Div className="pt-4">
                <ButtonSingle handleClick={() => submitDuration()}>
                  {AppTranslation.text("ok")}
                </ButtonSingle>
              </Div>
            )}
        </Div>
      )}
    </>
  );
};
